export const CloseSvg = () => {
  return (
    <svg
      width={"20"}
      height={"20"}
      viewBox={"0 0 20 20"}
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}>
      <path
        d={
          "M10.0006 8.82212L15.0726 3.75L16.2511 4.92851L11.1791 10.0006L16.25 15.0715L15.0715 16.25L10.0006 11.1791L4.92851 16.251L3.75 15.0725L8.8221 10.0006L3.75 4.92851L4.92851 3.75L10.0006 8.82212Z"
        }
        fill={"currentColor"}
      />
    </svg>
  );
};
